import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  adminRedirectTarget,
  kitchenSinkRedirectTarget,
} from './backoffice-redirect-urls'
import { getDtVite } from '@/lib/runtime-env'

/**
 * Parity with next.config.js redirects: /admin and /admin/* → backoffice /explore.
 */
export function AdminToBackofficeRedirect() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const target = adminRedirectTarget(
      pathname,
      getDtVite('DT_VITE_BACKOFFICE_URL') || '',
    )
    window.location.replace(target)
  }, [pathname])

  return null
}

/**
 * Parity with next.config.js: /internal/kitchen-sink* → backoffice explore kitchen-sink.
 */
export function KitchenSinkToBackofficeRedirect() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const target = kitchenSinkRedirectTarget(
      pathname,
      getDtVite('DT_VITE_BACKOFFICE_URL') || '',
    )
    window.location.replace(target)
  }, [pathname])

  return null
}
